export { initServices, getDetails, getPlacePredictions } from './src/maps-service'
export type {
  AutocompletePrediction,
  AutocompleteService,
  PlacesService,
  GeocoderAddressComponent,
  Services,
} from './src/maps-service'
export * from './src/helpers'
